import { theme } from '@lmc/ui-kit'

type SirenProps = {
  hasUnreadNotes: boolean
  isNoticeboardPath: boolean
}

const Siren = ({ hasUnreadNotes, isNoticeboardPath }: SirenProps) => {
  const color = isNoticeboardPath
    ? theme.color.neutral.color11
    : theme.color.background.quarternary
  return hasUnreadNotes ? (
    <svg
      aria-hidden="true"
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.4062 17.1875V18.5625L18.9062 17.1875V15.4688"
        stroke={color}
        strokeWidth="1.33"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
      <path
        d="M3.4375 9.96875H0.6875"
        stroke={color}
        strokeWidth="1.33"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
      <path
        d="M4.46875 6.53125L2.0625 5.15625"
        stroke={color}
        strokeWidth="1.33"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
      <path
        d="M4.46875 13.4062L2.0625 14.7812"
        stroke={color}
        strokeWidth="1.33"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
      <path
        d="M6.875 17.1875L20.0661 13.4186C20.4252 13.316 20.7411 13.0992 20.966 12.8009C21.1909 12.5027 21.3125 12.1394 21.3125 11.7659V8.17162C21.3125 7.79812 21.1909 7.43476 20.966 7.13656C20.7411 6.83835 20.4252 6.62151 20.0661 6.51888L6.875 2.75V17.1875Z"
        stroke={color}
        strokeWidth="1.33"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
      <path
        d="M18 8C20.2091 8 22 6.20914 22 4C22 1.79086 20.2091 0 18 0C15.7909 0 14 1.79086 14 4C14 6.20914 15.7909 8 18 8Z"
        fill="url(#paint0_linear_118_3394)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_118_3394"
          x1="18"
          y1="0"
          x2="18"
          y2="8"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF666D" />
          <stop offset="1" stopColor="#E0211F" />
        </linearGradient>
      </defs>
    </svg>
  ) : (
    <svg
      aria-hidden="true"
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.4062 17.1875V18.5625L18.9062 17.1875V15.4688"
        stroke={color}
        strokeWidth="1.33"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
      <path
        d="M3.4375 9.96875H0.6875"
        stroke={color}
        strokeWidth="1.33"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
      <path
        d="M4.46875 6.53125L2.0625 5.15625"
        stroke={color}
        strokeWidth="1.33"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
      <path
        d="M4.46875 13.4062L2.0625 14.7812"
        stroke={color}
        strokeWidth="1.33"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
      <path
        d="M6.875 17.1875L20.0661 13.4186C20.4252 13.316 20.7411 13.0992 20.966 12.8009C21.1909 12.5027 21.3125 12.1394 21.3125 11.7659V8.17162C21.3125 7.79812 21.1909 7.43476 20.966 7.13656C20.7411 6.83835 20.4252 6.62151 20.0661 6.51888L6.875 2.75V17.1875Z"
        stroke={color}
        strokeWidth="1.33"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
    </svg>
  )
}
export default Siren

// color: isNoticeboardPath ? colors.white : '#B8A6C9',
